import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

import Core from "../views/Core.vue";
import History from "../views/History.vue";
import Error from "../views/Error.vue";
import Chat from "../views/Chat.vue";
import Projects from "../views/Projects.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/projects/:id/skills/:skillId",
    name: "Core",
    component: Core,
  },
  {
    path: "/projects/:id/skills",
    name: "Core",
    component: Core,
  },
  {
    path: "/",
    name: "Home",
    component: Projects,
  },
  // {
  //   path: "/history/:id",
  //   name: "History",
  //   component: History,
  // },
  // {
  //   path: "/history/:id/error",
  //   name: "Error",
  //   component: Error,
  // },
  {
    path: "/project/:id/chat",
    name: "Chat",
    component: Chat,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
